module.exports = __webpack_public_path__ + "media/images/common/down_btn-cae1ca896a5cce36bc7cc874228bbbbd.png";